let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4PHEa")).then(() => parcelRequire('9KAfh'));